import * as React from 'react'
import PropTypes from 'prop-types'

interface TransfertIconProps extends React.SVGProps<SVGSVGElement> {

  strokeColor?:string
}


const TransfertWalletIcon: React.FC<TransfertIconProps>= ({

  strokeColor,
  ...props
}) => {
  // const strokeColor = isActive ? hoverStroke : defaultStroke

  return (

<svg width="25" height="25" viewBox="0 0 25 25" 
className={strokeColor}
fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_13656_65841)">
<path d="M17.7983 5.63547C19.6948 5.72086 20.8664 5.98685 21.6949 6.81549C22.9154 8.03588 22.9154 10.0001 22.9154 13.9284C22.9154 17.8568 22.9154 19.821 21.6949 21.0413C20.4746 22.2618 18.5104 22.2618 14.582 22.2618H10.4154C6.48699 22.2618 4.52281 22.2618 3.30242 21.0413C2.08203 19.821 2.08203 17.8568 2.08203 13.9284C2.08203 10.0001 2.08203 8.03588 3.30242 6.81549C4.26258 5.85533 5.68314 5.65059 8.15844 5.60693"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2.08203 11.8457H6.45414C7.19848 11.8457 7.57066 11.8457 7.90445 11.9624C8.10828 12.0336 8.2998 12.1361 8.47215 12.2662C8.75437 12.4792 8.96081 12.7888 9.3737 13.4082C9.78658 14.0276 9.99303 14.3372 10.2753 14.5502C10.4476 14.6803 10.6391 14.7828 10.843 14.854C11.1767 14.9707 11.5489 14.9707 12.2933 14.9707H12.7041C13.4485 14.9707 13.8207 14.9707 14.1544 14.854C14.3583 14.7828 14.5498 14.6803 14.7221 14.5502C15.0043 14.3372 15.2108 14.0276 15.6237 13.4082C16.0366 12.7888 16.2431 12.4792 16.5253 12.2662C16.6976 12.1361 16.8891 12.0336 17.093 11.9624C17.4267 11.8457 17.7989 11.8457 18.5433 11.8457H22.9154"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.5833 14.6195C14.2901 14.4802 14.0184 14.3029 13.7746 14.094C12.9944 13.4254 12.5 12.4327 12.5 11.3245C12.5 9.31101 14.1323 7.67871 16.1458 7.67871C18.1594 7.67871 19.7917 9.31101 19.7917 11.3245C19.7917 11.5014 19.7791 11.6753 19.7547 11.8454"  strokeWidth="2"/>
<path d="M12.3947 10.6405C11.8119 9.99423 11.457 9.13832 11.457 8.19954C11.457 6.18601 13.0893 4.55371 15.1029 4.55371C17.1164 4.55371 18.7487 6.18601 18.7487 8.19954C18.7487 8.37638 18.7361 8.55027 18.7118 8.72038"  strokeWidth="2"/>
<path d="M11.5943 9.74244C10.8394 9.66351 10.153 9.35418 9.60667 8.88601C8.82642 8.21735 8.33203 7.22468 8.33203 6.11654C8.33203 4.103 9.96433 2.4707 11.9779 2.4707C13.3696 2.4707 14.5792 3.25053 15.1936 4.39707"  strokeWidth="2"/>
</g>
<defs>
<clipPath id="clip0_13656_65841">
<rect width="25" height="25" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}

export default TransfertWalletIcon
